const SORT_DIRECTIONS = {
  ASCENDING: {key: 'ASCENDING', label: 'ascending'},
  DESCENDING: {key: 'DESCENDING', label: 'descending'},
};

export default SORT_DIRECTIONS;
